import { ComponentPropsWithoutRef, MouseEvent } from 'react';

import { cn } from '@components/primitives/utilities';

import { focusControl } from './focusControl';

import css from './styles.module.css';

export type InputGroupAddonAlign =
  | 'inline-start'
  | 'inline-end'
  | 'block-start'
  | 'block-end';

export interface InputGroupAddonProps extends ComponentPropsWithoutRef<'div'> {
  /** @default 'inline-start' */
  align?: InputGroupAddonAlign;
}

/** Non-editable content inside the group's box. */
export function InputGroupAddon({
  align = 'inline-start',
  className,
  onClick,
  ...props
}: InputGroupAddonProps) {
  function handleClick(event: MouseEvent<HTMLDivElement>) {
    onClick?.(event);
    focusControl(event, event.currentTarget.parentElement);
  }

  return (
    <div
      data-align={align}
      className={cn(css.addon, className)}
      onClick={handleClick}
      {...props}
    />
  );
}
